const styles = theme => ({
  flex: { flex: 1 },
  width: '100%',
  backgroundColor: theme.palette.background.paper,
  appHeader: {
    position: 'relative',
    marginTop: 0,
    backgroundColor: theme.palette.background.paper,
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/containers/meals/common/mealsHeader/MealsSelectionHeaderStyles.js